import { FixedWebWidthContentWrapper } from "@/shared/components/page/fixed-web-width-content-wrapper";
import React from "react";
import { PasswordForm } from "@/shared/components/text-box/password-form";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useLoginContext } from "@/features/auth/contexts/login-context";
import { useLocation, useNavigate } from "react-router-dom";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";


export const ResetPassCompleted = () => {
  // パスワードフォームに付与するID
  const passwordFormId = "signUpPass";
  const navigate = useNavigate();

  return (
    <>
      <LoginHeader content="パスワードの再設定" />
      <main>
        <section id="rePass">
          <nav className="step">
            <ol>
              <li className="done">再設定メールを送信</li>
              <li className="done">新パスワードの設定</li>
              <li className="active">再設定完了</li>
            </ol>
          </nav>
          <p>パスワードが再設定されました</p>
          <div className="notice">
            <p>新しいパスワードに更新されました。これまでのパスワードはご利用になれませんのでご注意ください。</p>
          </div>
          <nav className="btns">
            <BaseRoundButton
              buttonText="ログインへ"
              onClick={() => {
                navigate(EndpointPathNames.LOGIN)
              }}
              isActive={true}
              className="nav-main"
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};
